import { render, staticRenderFns } from "./PayOrdersWithoutSupport.vue?vue&type=template&id=4b97f71d&scoped=true&"
import script from "./PayOrdersWithoutSupport.vue?vue&type=script&lang=js&"
export * from "./PayOrdersWithoutSupport.vue?vue&type=script&lang=js&"
import style0 from "./PayOrdersWithoutSupport.vue?vue&type=style&index=0&id=4b97f71d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b97f71d",
  null
  
)

export default component.exports